<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  @if (fitnessAndProprietyData ) {
    <form [formGroup]="fitnessAndProprietyForm">
      @for (category of questions_Category; track category) {
        <div>
          <h1 class="bofa--heading is-4">{{category}} Questions</h1>
          @for (data of getQuestionsbasedCategory(category); track data; let i = $index) {
            <div [formGroup]="data">
              <div #item>
                <span class="minor-list-space" [id]="'await-trial-label-' + i"><abbr title="required">*
                </abbr>{{data.controls.questions.value}}</span>
                <mat-radio-group [attr.aria-labelledby]="'await-trial-label-' + i" formControlName="answer" required
                  class="bottom-space minor-radio-padding radio-flex">
                  <mat-radio-button class="minor-list-space radio-padding field-space" value=1 name="answer">Yes
                  </mat-radio-button>
                  <mat-radio-button value=0 class="field-space" name="answer">No</mat-radio-button>
                </mat-radio-group>
                @if (data.controls.answer.value === '1') {
                  <div>
                    @if (fitnessAndProprietyData.jobCountryId !== 78) {
                      <mat-form-field class="max-zoom field-space non-required"
                        >
                        <mat-label>Please provide description</mat-label>
                        <input matInput formControlName="description" maxlength="150">
                      </mat-form-field>
                    }
                    @if (fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value === 53) {
                      <label
                        id="descriptionDesc" for="descriptionInput" class="field-space">Please provide description and upload
                        Court Order and Court Room Check (CRC) on the Certification Tab
                      </label>
                    }
                    @if (fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value === 53) {
                      <mat-form-field class="max-zoom field-space non-required-ous" aria-describedby="descriptionDesc"
                        >
                        <input id="descriptionInput" matInput formControlName="description" maxlength="150" placeholder="Please provide description">
                      </mat-form-field>
                    }
                    @if (fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value !== 53) {
                      <mat-form-field class="max-zoom field-space non-required"
                        >
                        <mat-label>Please provide description</mat-label>
                        <input matInput formControlName="description" maxlength="150">
                      </mat-form-field>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </form>
  } @else {
    @if (isIndiaGBS) {
      <span>
        Loading Criminal History Questions...
      </span>
    }
    @if (!isIndiaGBS) {
      <span>
        Loading Fitness and Propriety Questions...
      </span>
    }
  }
</div>

